// Import from conductor library - MfRemoteDebugService has NO Angular dependencies
import { MfRemoteDebugService } from '@complexcare/conductor';

// Initialize remote debug service
const debugService = new MfRemoteDebugService('web.admin');

// Log bootstrap start
debugService.logBootstrapStart();

import('./bootstrap')
	.then(() => {
		debugService.logBootstrapSuccess();
	})
	.catch((err) => {
		debugService.logBootstrapError(err);
	});
